import { Smile, RefreshCw } from 'lucide-react';
import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const JokeOfTheHourSection = () => {
  const [joke, setJoke] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPunchline, setShowPunchline] = useState(false);

  const fetchJoke = async () => {
    try {
      setLoading(true);
      setShowPunchline(false);
      const response = await axios.get(`${API}/joke/hourly`);
      setJoke(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching joke:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJoke();
    // Refresh every hour
    const interval = setInterval(fetchJoke, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="content-card" data-testid="joke-section">
      <div className="card-header">
        <h2>
          <Smile size={20} className="inline" /> Joke of the Hour
        </h2>
        <Button 
          onClick={fetchJoke} 
          variant="ghost" 
          size="sm"
          className="refresh-joke-btn"
          title="Get new joke"
        >
          <RefreshCw size={16} />
        </Button>
      </div>
      <div className="card-content joke-content">
        {loading ? (
          <p className="loading-text">Loading joke...</p>
        ) : joke ? (
          <div className="joke-container">
            <div className="joke-setup">
              <p>{joke.setup}</p>
            </div>
            
            {!showPunchline ? (
              <Button 
                onClick={() => setShowPunchline(true)}
                className="reveal-btn"
                variant="outline"
              >
                Reveal Punchline
              </Button>
            ) : (
              <div className="joke-punchline">
                <p>{joke.punchline}</p>
              </div>
            )}
            
            {joke.category && (
              <div className="joke-category">
                Category: {joke.category}
              </div>
            )}
          </div>
        ) : (
          <p className="no-data">Unable to load joke</p>
        )}
      </div>
    </div>
  );
};

export default JokeOfTheHourSection;
